import { AuthAction } from "src/features/auth/actions";
import { User } from "src/features/auth/types";

export interface AuthState {
	isInitialized: boolean;
	isLoading: boolean;
	isAuthenticated: boolean;
	user: User | null;
	error: unknown | null;
}

const initialState: AuthState = {
	isInitialized: false,
	isLoading: false,
	isAuthenticated: false,
	user: null,
	error: null
};

export function authReducer(
	state: AuthState = initialState,
	action: AuthAction
): AuthState {
	if (action.type === "INITIALIZE_START") {
		return { ...initialState, isLoading: true };
	}
	if (action.type === "INITIALIZE_SUCCESS") {
		const { user } = action.payload;
		return {
			...state,
			isInitialized: true,
			isLoading: false,
			isAuthenticated: true,
			user
		};
	}
	if (action.type === "INITIALIZE_FAILURE") {
		return {
			...state,
			isInitialized: true,
			isLoading: false,
			isAuthenticated: false,
			user: null,
			error: action.payload.error
		};
	}
	if (action.type === "KEEP_ALIVE_FAILURE") {
		return {
			...state,
			isAuthenticated: false,
			user: null,
			error: action.payload.error
		};
	}
	if (action.type === "UPDATE_USER" && state.user !== null) {
		return { ...state, user: { ...state.user, ...action.payload.user } };
	}
	return state;
}
